module.exports = __webpack_public_path__ + "img/Cleaner-1536x1536.34522bc3.png";